import React, { useCallback, useEffect, useRef, useState } from 'react';
import './Mobile.scss';

export const Mobile = () => {
  
  const learnMoreUrl = "https://www.bluejeans.com/products/events/studio";

  return (
  <div className="mobile-container">
    <div className="mobile-center">
      <div className="logo"></div>

      <div className='title'>Mobile devices are not supported</div>
      <div className='text'>To experience the BlueJeans Studio demo,<br/>please switch to a laptop or a desktop computer.</div>

      <a className='btn1 learn-more' href={learnMoreUrl} target='_blank' rel='noreferrer'>Learn More</a>
      <div className='desktop'></div>
    </div>
  </div>
  )
}